import { Dispatch } from "redux";
import { Action } from "./actions";
import { SystemActions } from "./action_types";
import { System } from "../types";
import axios from "axios";

export const fetchSystems = () => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/system`;
      const headers = { Authorization: `bwenvdev` };

      const { data } = await axios.get(url, { headers });

      dispatch({
        type: SystemActions.FETCH_SYSTEMS,
        payload: data.systems
      });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
};

export const createSystem = (body: System) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/system/create`;
      const headers = { Authorization: `bwenvdev` };

      return axios.post(url, body)
        .then(_ => {
          dispatch({
            type: SystemActions.CREATE_SYSTEM,
            payload: body
          });
        });


    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
};

export const deleteSystem = (systemCode: string) => {
  return async (dispatch: Dispatch<Action>) => {
    const baseUrl = `${process.env.REACT_APP_UMS_API_BASE_URL}/system/${systemCode}`;
    const headers = { Authorization: `bwenvdev` };

    return axios.delete(baseUrl, { headers })
      .then(() => {
        dispatch({
          type: SystemActions.DELETE_SYSTEM,
          payload: systemCode
        });
      })
      .catch(err => {
        console.error("Error deleting system:", err);
      });
  };
};


export const updateSelectedSystem = (system: string) => {
  console.log(system)
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: SystemActions.SELECT_SYSTEM,
      payload: system
    })
  }
}